const faqs = [
  {
    q: 'Es ExamsReactor un examen oficial?',
    a: 'No. Somos un simulador independiente de practica. Nuestros reportes te ayudan a prepararte para el examen oficial del vendor (Microsoft, AWS), pero el examen real lo rindes en sus plataformas.',
  },
  {
    q: 'De donde vienen las preguntas?',
    a: 'Todas las preguntas son ORIGINALES, creadas desde los objetivos oficiales publicos (Skills Measured, Exam Guides) y revisadas manualmente. No usamos ni reciclamos dumps.',
  },
  {
    q: 'Puedo cancelar cuando quiera?',
    a: 'Si. Sin contrato, sin penalidad. Cancelas con un click y mantienes acceso hasta el final del periodo pagado.',
  },
  {
    q: 'Hay reembolso?',
    a: 'Si — 48 horas desde la compra o renovacion. Self-service desde tu cuenta.',
  },
  {
    q: 'Que pasa con mi historial si cancelo?',
    a: 'Tu historial nunca se borra. Puedes volver a suscribirte y continuar donde dejaste.',
  },
  {
    q: 'Que paises soportan?',
    a: 'Cobramos en Peru, Chile, Brasil, Colombia, Mexico, Argentina y Espana. Si estas fuera, escribenos a soporte@examsreactor.com.',
  },
  {
    q: 'Las preguntas se actualizan?',
    a: 'Si. Cada certificacion tiene fecha de ultima revision visible. Cuando un blueprint cambia, revisamos y actualizamos los items afectados.',
  },
  {
    q: 'Puedo descargar mi reporte?',
    a: 'Si — los suscriptores premium pueden descargar reporte PDF por examen rendido.',
  },
];

export function FAQ() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold tracking-tight">Preguntas frecuentes</h1>
      <p className="mt-3 text-text-secondary">
        Lo que mas nos preguntan. Si no encuentras tu respuesta aqui, escribenos.
      </p>

      <div className="mt-10 space-y-6">
        {faqs.map((f) => (
          <details
            key={f.q}
            className="card group cursor-pointer transition-colors hover:border-accent-primary/50"
          >
            <summary className="flex items-center justify-between text-lg font-semibold">
              <span>{f.q}</span>
              <span className="text-text-tertiary group-open:rotate-90 transition-transform">→</span>
            </summary>
            <p className="mt-3 text-text-secondary">{f.a}</p>
          </details>
        ))}
      </div>

      <div className="mt-12 card text-center">
        <p className="text-text-secondary">No encuentras tu respuesta?</p>
        <a href="mailto:paul.marquina@outlook.com" className="btn-primary mt-4">
          Escribenos
        </a>
      </div>
    </div>
  );
}
